import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IoIosClose } from 'react-icons/io'
import { TbMenu } from 'react-icons/tb'
import { Text } from '..'
import { SOCKET_URL } from '../../../core/constants/urls'
import { deepCopy } from '../../../core/utils/common'
import { useCreateStake } from '../core/services'
import AddStakingModal from './AddStakingModal'
import Select from '../../global/select/Select'
import { formatNumber } from '..'
import StackingSupportModal from './StackingSupportModal'
import CoinImg from '../../../components/common/CoinImg'

const notes = [
	'با مشارکت در تامین نقدینگی استخرهای معاملات حرفه ای، ‌در سود معاملات شریک می شوید.',
	'کاربران با مشارکت در استخر نقدینگی و طبق شرایط و ضوابط مشخص شده کسب سود می نمایند.',
	'در این محصول برای کاربرانی که خودشان تحمل ریسک معاملات حرفه ای را ندارند، روش دیگری برای کسب سود ازین نوع معاملات در دکسکو فراهم شده است.',
	'در این قابلیت کاربران (وکالت دهندگان) با مشارکت در تامین نقدینگی استخر ها، در سود معاملات حرفه ای شریک میشوند.',
	'با انتخاب طرح مورد نظر ، میزان سود و‌ مدت زمان مشارکت به کاربر نمایش داده شده و توسط کاربر انتخاب میشود.',
	'در مدت زمان انتخاب شده ، سرمایه مورد نظر کاربر  در استخر مشارکت قفل میشود.',
	'سود مشارکت بصورت ماهانه واریز میشود.',
	'در صورت انصراف کاربر پیش از موعد ، سود های کسب شده بعلاوه ٪۲۰ از سرمایه قفل شده از کاربر کسر میشود.',
	'میزان درصد سود دریافتی تمامی استخرها حدودی می باشد.',
	'مشارکت در استخر های نقدینگی به منزله پذیرش تمام موارد فوق است.',
]

const CreateStakingStage2 = ({ plans, currency, coins = [], onCurrencyChange }) => {
	const onboard = useMemo(() => {
		let res = []
		if (!!currency && plans?.length) {
			res = plans.filter((p) => p.currency === currency)
		}
		return res
	}, [plans, currency])

	const { t } = useTranslation()
	const [input, setInput] = useState([])
	useEffect(() => {
		setInput(onboard.map((_) => ({ value: '', isError: false, error: '' })))
	}, [onboard])

	const initialAddModal = { show: false, data: null }
	const initialSupportModal = { show: false, data: null }
	const [addModal, setAddModal] = useState(initialAddModal)
	const [addSupport, setSupportModal] = useState(initialAddModal)
	const openAddModal = (data) => setAddModal({ show: true, data })
	const closeAddModal = () => setAddModal(initialAddModal)
	const openSupportModal = (data) => setSupportModal({ show: true, data })
	const closeSupportModal = () => setSupportModal(initialSupportModal)

	const onInputChange = (v, idx) => {
		const newInput = deepCopy(input)
		newInput[idx].value = v

		const minAmount = onboard[idx]?.minAmount
		const maxAmount = onboard[idx]?.maxAmount

		if (v < minAmount) {
			newInput[idx].isError = true
			newInput[idx].error = 'min-amount-error'
		}
		if (maxAmount) {
			if (v > maxAmount) {
				newInput[idx].isError = true
				newInput[idx].error = 'max-amount-error'
			}
		}

		if (v >= minAmount && v <= maxAmount) {
			newInput[idx].isError = false
			newInput[idx].error = ''
		}

		setInput(newInput)
	}

	const { mutate: createStake, isLoading: createStakeLoading } = useCreateStake(closeAddModal)

	const onSubmit = () => {
		createStake({
			planId: addModal.data.plan.id,
			amount: parseFloat(addModal.data.amount),
		})
		// closeAddModal()
		// openSupportModal(null)
	}

	const getFakeInterestRate = (item) => {
		switch (item.currency) {
			case 'usdt':
				if (item.periodDays === 90) return '3.5 ≈ 4.5'
				if (item.periodDays === 360) return '4.5 ≈ 6.5'
				return '6.5 ≈ 7.5'
			case 'btc':
				if (item.periodDays === 90) return '1.5 ≈ 2.5'
				if (item.periodDays === 360) return '2.5 ≈ 3.5'
				return '4 ≈ 5'
			default:
				return item.interestRate
		}
	}

	return (
		<div className='flex flex-col gap-3 max-w-[1200px] mx-auto'>
			<AddStakingModal
				onClose={closeAddModal}
				detail={addModal}
				onSubmit={onSubmit}
				loading={createStakeLoading}
			/>

			<StackingSupportModal onClose={closeSupportModal} detail={addSupport} />

			<div className='flex items-center gap-2 justify-between'>
				<Text tid={'active-plans'} className={'dark:text-gray-100 text-lg font-semibold'} />
				<Select
					options={coins}
					value={currency}
					onChange={onCurrencyChange}
					singleSelect={true}
					className={'min-w-[200px]'}
					template={(coin) => (
						<div className={'flex gap-2 items-center'}>
							<CoinImg size={26} id={coin} />
							<span>{coin?.toUpperCase()}</span>
						</div>
					)}
				/>
			</div>

			<div className={'bg-slate-500 bg-opacity-10 w-full h-[1px] mx-auto'} />
			<div className={'flex flex-col gap-1 w-full  mx-auto px-4'}>
				{notes.map((item) => {
					return (
						<div className={'flex items-start text-[0.8rem] gap-2'}>
							<div className={'w-[10px] mt-[6px] h-[10px] rounded-[50%] bg-cBlue'} />
							<div className={'w-[95%] text-justify'}>
								<span>{item}</span>
							</div>
						</div>
					)
				})}
			</div>
			<div className={'bg-slate-500 bg-opacity-10 w-full my-2 h-[1px] mx-auto'} />
			<div className={'grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-2'}>
				{onboard.map((item, idx) => {
					return (
						<div
							key={item.id}
							className={'rounded-md dark:bg-secondaryBg bg-slate-100 p-3 flex flex-col gap-2'}
						>
							<div
								className={`flex justify-between items-center gap-2 
                rounded-md border-cBlue/60 border-opacity-30 dark:bg-darkThirdBg border-[1px] 
                px-3 h-[52px] w-full`}
							>
								<CoinImg size={36} id={currency} />
								<span>{item.name}</span>
								<div />
							</div>

							<div
								className={`flex justify-center items-center gap-2 
                rounded-md border-cBlue/60 border-opacity-30 dark:bg-darkThirdBg border-[1px] 
                px-3 h-[52px] w-full`}
							>
								<span className={'text-[0.85rem]'}>
									<span>{item.periodDays}</span>
									<span> </span>
									<Text tid={'days'} />
								</span>
							</div>

							<div
								className={`flex flex-col 
              rounded-md border-cBlue/60 border-opacity-30 bg-white dark:bg-secondaryBg border-[1px] 
                px-[1px] w-full`}
							>
								<Text tid={'staking-plan-desc'} className={'text-sm py-3 mx-auto'} />
								<div className={'w-full h-[1px] bg-cBlue/40 bg-opacity-30'} />
								<div className={'grid grid-cols-2'}>
									<div
										className={
											'flex flex-col items-center justify-center border-l-[1px] border-cBlue/60 border-opacity-30 py-4'
										}
									>
										<span className={'dark:text-gray-100 font-semibold'}>{`${getFakeInterestRate(
											item
										)} %`}</span>
										<Text className={'text-sm'} tid={'income-profit'} />
									</div>

									<div
										className={
											'flex flex-col items-center justify-center border-cBlue/60 border-opacity-30 py-4'
										}
									>
										<span
											dir={'ltr'}
											className={'font-semibold dark:text-gray-100 text-xs'}
										>{`${formatNumber(item.minAmount, {
											type: item.currency,
										})} ${item.currency.toUpperCase()}`}</span>
										<Text tid={'stakeMinAmount'} className={'text-[0.675rem]'} />
										<span
											dir={'ltr'}
											className={'font-semibold dark:text-gray-100 mt-2 text-xs'}
										>{`${formatNumber(item.maxAmount, { type: item.currency }) || '∞'
											} ${item.currency.toUpperCase()}`}</span>
										<Text tid={'stakeMaxAmount'} className={'text-[0.675rem]'} />
									</div>
								</div>
							</div>

							<div className='flex flex-col gap-1 text-sm mt-3'>
								<Text tid={'staking-amount'} />
								<div
									className={
										'rounded-md border-[1px] border-gray-500 gap-2 border-opacity-20 flex items-center py-3 px-3 bg-white dark:bg-secondaryBg'
									}
								>
									<TbMenu size={20} />
									<input
										value={input[idx]?.value}
										onChange={(e) => onInputChange(e?.target?.value, idx)}
										className={
											'appearance-none border-none w-[80%] bg-transparent lg:text-sm text-xs'
										}
										placeholder={t('enter-staking-amount')}
									/>
									<div onClick={() => onInputChange('', idx)}>
										<IoIosClose size={20} />
									</div>
								</div>
								<div className={'flex items-center gap-1 justify-between'}>
									{input[idx]?.isError ? (
										<Text tid={input[idx]?.error} className={'text-xs text-red-500'} />
									) : null}
									{input[idx]?.value ? (
										<span dir={'ltr'}>
											{formatNumber(input[idx]?.value, { type: item.currency })}{' '}
											{item.currency?.toUpperCase()}
										</span>
									) : null}
								</div>
							</div>

							<div
								onClick={() => {
									if (input[idx]?.value && !input[idx]?.isError) {
										openAddModal({ plan: item, amount: input[idx]?.value })
									}
								}}
								className={`
                  cursor-pointer mt-3 h-[42px] flex items-center justify-center w-full 
                  ${input[idx]?.value && !input[idx]?.isError
										? 'bg-cBlue text-slate-200'
										: 'dark:bg-gray-600 bg-gray-300 bg-opacity-50'
									} rounded-md 
                `}
							>
								<Text tid={'start-staking'} className={'text-sm'} />
							</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default CreateStakingStage2
